import request from '../services/request';

export const getCommunityMembers = (page, type) => {
  const path = `/community/${type}`;
  return request.get(path, {
    params: {
      page,
      perPage: 50,
    },
  });
};

export const getCreators = (page, limit) => request.get('/community/creators', {
  params: { page, limit },
});

export const getUsersOfType = (
  page,
  limit,
  type,
  orderBy,
) => request.get('/admin/users', { params: { page, limit, type, orderBy } });

export const getCommunityMember = username => request.get(`/member/@${username}`);

export const searchCreators = q => request.get('/search/creators', { params: { q } });
export const searchSupporters = q => request.get('/search/supporters', { params: { q } });
export const featureCreator = (id, category) => request.put('/admin/featureCreator', {
  id,
  category,
});
export const superfeatureCreator = id => request.put('/admin/superfeatureCreator', { id });
export const unfeatureCreator = id => request.put('/admin/unfeatureCreator', { id });
export const unsuperfeatureCreator = id => request.put('/admin/unsuperfeatureCreator', { id });
export const getFeaturedCreators = ({ pagination, category = '' }) => request.get('/community/featured', {
  params: {
    pagination,
    category,
  },
});
export const sendMessageToSupporters = (formData, to, contentID) => request.post(
  '/community/send-message',
  { formData },
  { params: { to, contentID } },
);

export const sendMessageToMember = (
  formData,
  recipientEmail,
) => request.post('/community/send-message-to-member', { formData, recipientEmail });

export const getSubscriberCSVList = params => request.get('/community/subscribers.csv', { params });
export const getSupporterCSVList = () => request.get('/community/supporters.csv');
export const getClaimerCSVList = contentID => request.get('/community/claimers.csv', { params: { contentID } });

export const superfeatureUser = id => request.put(`admin/users/${id}/super-feature`);
export const getSuperfeaturedUsers = () => request.get('community/super-featured');
export const addDescription = (id, body) => request.post(`admin/users/${id}/description`, body);
